// extracted by mini-css-extract-plugin
export default {"paper":"TextAlign_paper__ayHKT","row":"TextAlign_row__SoqVY"};